module.exports = __webpack_public_path__ + "static/footer-poster-e9e7ac9a4170ea6c402f490f5fe55bb9.jpg";